"use client"
/* */
const locales = {"de-DE": {  "slider.decrement": `Wert verkleinern`,
  "slider.increment": `Wert erhöhen`,
},"en-US": {  "slider.decrement": `Decrement value`,
  "slider.increment": `Increment value`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@3ed2dc50f997451bdd85a713c54e1025.mjs.map
